import React from "react";
import Field from "components/molecules/Field";
import Form from "components/molecules/Form/Form";
import {useForm} from "components/molecules/Form";
import {FiSearch} from "react-icons/fi";
import {TfiExport} from "react-icons/tfi";
import {ReportsHeaderWrap} from "components/atoms/Reports/Reports.styles";
import Button from "components/molecules/Button";

/**
 * ReportsHeader
 */
const ReportsHeader = ({onFiltersChange, onExport, exportLoading}) => {
    const [form] = useForm();

    const handleChange = () => {
        setTimeout(() => {
            const values = form.getFieldsValue();
            const {fromdate, todate, search} = values;
            if (onFiltersChange) {
                onFiltersChange({
                    startDate: fromdate || null,
                    endDate: todate || null,
                    search: search || "",
                });
            }
        }, 0);
    };

    return (
        <ReportsHeaderWrap>
            <div className="left-wrap">
                <h2>Reports</h2>
            </div>
            <Form
                form={form}
                className="rightwrapper"
                onChange={handleChange}
                initialValues={{search: "", fromdate: null, todate: null}}>
                <div className="date-wrap">
                    <Form.Item type="date" rounded name="fromdate" $bgWhite inputSm noMargin>
                        <Field />
                    </Form.Item>
                    <label>To</label>
                    <Form.Item type="date" rounded name="todate" $bgWhite inputSm noMargin>
                        <Field />
                    </Form.Item>
                </div>
                <div className="right-content">
                    <Form.Item
                        type="search"
                        rounded
                        name="search"
                        lg
                        placeholder="Search..."
                        $bgWhite
                        inputSm
                        noMargin
                        suffix={<FiSearch />}>
                        <Field />
                    </Form.Item>
                    <Button sm type="button" onClick={onExport} disabled={exportLoading}>
                        {exportLoading ? (
                            "Exporting…"
                        ) : (
                            <>
                                <TfiExport /> Export
                            </>
                        )}
                    </Button>
                </div>
            </Form>
        </ReportsHeaderWrap>
    );
};

export default ReportsHeader;
